// extracted by mini-css-extract-plugin
module.exports = {"container":"q_k","bg":"q_C","inner":"q_l","copy1":"q_bf","copy2":"q_bg","anim1":"q_bh","links":"q_K","button":"q_L","animationMarquee":"q_j"};